import type { TableHeader, TableItem } from '@svoi-ui/interfaces/table'
import { isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'
import { BaseModel } from '~/shared/model'

export default class AccountReportsTableModel extends BaseModel {
  data: TableItem[] = []
  headers: TableHeader[] = []

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}
